/**
 * Which UI language a stored value means.
 *
 * Kept free of project imports on purpose: apollo/index.js needs it to build the `locale`
 * header, and utils/locale/index.js needs the Apollo client to save the preference, so
 * putting both in one module would make the two import each other.
 */

export const SUPPORTED_LANGUAGES = ['es', 'en', 'pt', 'tr'];
export const DEFAULT_LANGUAGE = 'es';

// Values found in users.locale that are not language codes but clearly mean one.
const LANGUAGE_ALIASES = { us: 'en' };

/**
 * Turns any stored form ('es', 'es_ES', 'en-US', 'EN', 'us') into a language the UI ships.
 * Anything unrecognized falls back to the default, so i18next, <html lang> and the
 * language selectors never receive a code they cannot show.
 * @param {string|null|undefined} raw
 * @returns {'es'|'en'|'pt'|'tr'}
 */
export const toUiLanguage = (raw) => {
  const code = String(raw || '').trim().toLowerCase().slice(0, 2);
  const language = LANGUAGE_ALIASES[code] || code;
  return SUPPORTED_LANGUAGES.includes(language) ? language : DEFAULT_LANGUAGE;
};
